import React from "react"
import withStyles from "react-jss"
import {
  inputStyle,
  MOBILE_BREAKPOINT,
  SMALL_MOBILE_BREAKPOINT,
} from "../../data/globalStyles"
import { NAME, ABV, VOLUME } from "../../utils/helper"

import { compareStrings } from "../../utils/format"
import Dropdown from "./Dropdown"
import cocktailData from "../../data/cocktails"
import ingredientsData from "../../data/ingredients"
import { closeIcon } from "../../assets"
import colors from "../../data/colors"

const styles = {
  cocktailBox: {
    display: "flex",
    flexDirection: "row",
    flexWrap: "wrap",
    margin: "1rem 0 0 0",
    "@media only screen and (max-width: 920px)": {
      justifyContent: "flex-start",
      "& > :last-child": {
        marginRight: 0,
      },
    },
  },
  inputContainer: {
    position: "relative",
    width: "18.5%",
    marginRight: "1rem",

    "@media only screen and (max-width: 1060px)": {
      width: "17.5%",
    },
    "@media only screen and (max-width: 920px)": {
      width: "30%",
      minWidth: "100px",
      maxWidth: "160px",
      marginTop: "20px",
    },
  },
  inputContainerAbv: {
    position: "relative",
    width: "18.5%",
    marginRight: "1rem",

    "@media only screen and (max-width: 1060px)": {
      width: "17.5%",
    },
    "@media only screen and (max-width: 920px)": {
      width: "30%",
      minWidth: "100px",
      maxWidth: "160px",
    },
    "@media only screen and (max-width: 960px)": {
      marginTop: "20px",
    },
  },

  numberInput: {
    ...inputStyle,
    width: "100%",
  },
  unit: {
    position: "absolute",
    right: "1.5rem",
    transform: "translate(50%, 50%)",
    fontFamily: "Futura",
    fontWeight: 500,
    fontSize: "calc(12px + (20 - 12) * ((100vw - 300px) / (1600 - 300)))",
    textAlign: "center",
    color: "#252525",
    top: "1.8rem",
    margin: 0,
    lineHeight: 0,
    "@media only screen and (max-width: 920px)": {
      top: "2.3rem",
    },
    [`@media only screen and (max-width: ${SMALL_MOBILE_BREAKPOINT}px)`]: {
      top: "1.52rem",
    },
  },
  close: {
    width: "23px",
    height: "23px",
    cursor: "pointer",
    marginTop: "1.2rem",
    "@media only screen and (max-width: 920px)": {
      display: "none",
    },
  },
  error: {
    fontSize: "12px",
    fontStyle: "italic",
    color: "#D06434",
    textAlign: "center",
    display: "block",
  },
  text: {
    margin: "0 0 -0.5rem 0",
    fontFamily: "Futura",
    fontWeight: 500,
    fontSize: "calc(14px + (16 - 14) * ((100vw - 300px) / (1600 - 300)))",
    color: colors.black,
    width: "100%",
  },
}

const IngredientsRows = ({
  classes,
  data,
  setData,
  errors,
  setErrors,
  updateData,
  deleteIngredient,
  populateCocktailIngredientsData,
  populateIngredientData,
}) => {
  const handleDropdownChange = (inputValue, dataIndex) => {
    // if user selected a cocktail, populate the data for all ingredients

    const cocktail = cocktailData.find((d) =>
      compareStrings(d.name, inputValue)
    )

    const ingredient = ingredientsData.find((d) =>
      compareStrings(d.name, inputValue)
    )

    if (cocktail) {
      populateCocktailIngredientsData(cocktail, dataIndex)
      return
    }
    // if user selected an ingredient, auto populate ingredint data
    else if (ingredient) {
      populateIngredientData(ingredient, dataIndex)
      return
    }
    updateData(
      {
        target: {
          value: inputValue,
        },
      },
      NAME,
      dataIndex
    )
  }

  const INITIAL_INGREDIENTS = {
    name: "",
    volume: "",
    abv: "",
  }

  return (
    <div>
      <p className={classes.text}>What’s in it?</p>
      {data.map((d, i) => (
        <div className={classes.cocktailBox} key={i}>
          <Dropdown
            value={d.name}
            errors={errors}
            setErrors={setErrors}
            setData={setData}
            dataIndex={i}
            closeButton={data.length}
            deleteIngredient={deleteIngredient}
            handleDropdownChange={handleDropdownChange}
            placeholder="Start typing a cocktail, ingredient or brand"
          />

          <div className={classes.inputContainer}>
            <input
              className={classes.numberInput}
              placeholder="Volume"
              type="number"
              value={d.volume}
              onChange={(e) => {
                setErrors((prevState) => ({
                  ...prevState,
                  ingredientVolume: false,
                }))
                updateData(e, VOLUME, i)
              }}
            />
            <p className={classes.unit}>oz.</p>
            {errors.ingredientVolume[i] && (
              <span className={classes.error}>how much of this?</span>
            )}
          </div>
          <div
            className={classes.inputContainerAbv}
            //style={{ marginRight: "-2%" }}
          >
            <input
              className={classes.numberInput}
              placeholder="ABV"
              type="number"
              value={d.abv}
              onChange={(e) => {
                setErrors((prevState) => ({
                  ...prevState,
                  ingredientAbv: false,
                }))
                updateData(e, ABV, i)
              }}
            />
            <p className={classes.unit}>%</p>
            {errors.ingredientAbv[i] && (
              <span className={classes.error}>don't forget the ABV</span>
            )}
          </div>
          {data.length > 1 ? (
            <img
              className={classes.close}
              src={closeIcon}
              onClick={() => deleteIngredient(i)}
              alt="Remove the ingredient."
            />
          ) : (
            <img
              className={classes.close}
              src={closeIcon}
              onClick={() => setData([INITIAL_INGREDIENTS])}
              alt="Remove the ingredient."
            />
          )}
        </div>
      ))}{" "}
    </div>
  )
}

export default withStyles(styles)(IngredientsRows)
